module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_03-45a913215835dfc828b7783ecd4ac6fd.png";